import {
  ChannelTypeEnum,
  MailConversationDataType,
  WechatConversationDataType,
  WecomConversationDataType,
} from "../../types";
import EventBus from "../event-bus";

const globalChannelMessageHook = new EventBus<{
  channelType: ChannelTypeEnum;
  conversation:
    | WechatConversationDataType
    | WecomConversationDataType
    | MailConversationDataType;
}>("globalChannelMessageHook");

export default globalChannelMessageHook;
